<template>
  <section class="section contact-page">
    <div class="contact-wrapper">
      <h1>{{ $t('contact.title') }}</h1>
      <p>{{ $t('contact.subtitle') }}</p>

      <div class="contact-container">
        <!-- Form -->
        <form class="contact-form">
          <input type="text" :placeholder="$t('contact.name')" required />
          <input type="email" :placeholder="$t('contact.email')" required />
          <textarea :placeholder="$t('contact.message')" rows="5" required></textarea>
          <button type="submit" class="btn">{{ $t('contact.send') }}</button>
        </form>

        <!-- Bilgiler -->
        <div class="contact-info">
          <h4>{{ $t('contact.infoTitle') }}</h4>
          <p>📧 info@osmanlicabelgeler.com</p>
          <p>📞 +90 501 571 33 33</p>
          <p>📍 Eyüp Sultan, Esma Sk. No: 3, 34885 Sancaktepe/İstanbul</p>
        </div>
      </div>

      <!-- Harita -->
      <div class="map-container">
        <iframe
          src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2993.189597192779!2d29.2362183!3d41.0047544!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x14cab83ea8aeef63%3A0x2fc31f30a716b820!2sEsma%20Sk.%203%2C%2034885%20Sancaktepe%2F%C4%B0stanbul!5e0!3m2!1str!2str!4v1716900000000"
          width="100%"
          height="300"
          style="border:0;"
          :allowfullscreen="true"
          loading="lazy"
          referrerpolicy="no-referrer-when-downgrade"
        ></iframe>
      </div>
    </div>
  </section>
</template>


<style scoped>
.contact-page {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 60px 20px;
  background-color: rgba(255, 255, 255, 0.156);
  min-height: calc(100vh - 100px); /* header ve footer dışında kalan alan */
}

.contact-wrapper {
  background: white;
  max-width: 1100px;
  width: 100%;
  border-radius: 16px;
  box-shadow: 0 0 24px rgba(0, 0, 0, 0.1);
  padding: 40px 30px;
  text-align: center;
}

.contact-wrapper h1 {
  font-size: 2rem;
  margin-bottom: 10px;
  color: #222;
}

.contact-wrapper p {
  font-size: 1.1rem;
  margin-bottom: 30px;
  color: #444;
}

.contact-container {
  display: flex;
  flex-wrap: wrap;
  gap: 40px;
  justify-content: space-between;
}

.contact-form {
  flex: 1;
  min-width: 300px;
  display: flex;
  flex-direction: column;
  gap: 15px;
}

.contact-form input,
.contact-form textarea {
  padding: 12px;
  border: 1px solid #ccc;
  border-radius: 8px;
  font-size: 1em;
}

.contact-form .btn {
  background-color: #004c8c;
  color: white;
  padding: 12px;
  border: none;
  border-radius: 8px;
  cursor: pointer;
  transition: background 0.3s ease;
}

.contact-form .btn:hover {
  background-color: #003865;
}

.contact-info {
  flex: 1;
  min-width: 250px;
  background: #f4f4f4;
  padding: 20px;
  border-radius: 12px;
  box-shadow: 0 0 8px rgba(0, 0, 0, 0.05);
  text-align: left;
}

.contact-info h4 {
  margin-top: 0;
  margin-bottom: 10px;
  font-size: 1.1rem;
  color: #333;
}

.contact-info p {
  margin: 6px 0;
  color: #444;
  font-size: 0.95rem;
}

.map-container {
  margin-top: 40px;
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 0 8px rgba(0, 0, 0, 0.1);
}
@media (max-width: 768px) {
  .contact-wrapper {
    padding: 30px 20px;
  }

  .contact-container {
    flex-direction: column;
    gap: 20px;
  }

  .contact-form,
  .contact-info {
    width: 100%;
    min-width: unset;
  }

  .contact-form input,
  .contact-form textarea {
    font-size: 0.95em;
  }

  .contact-info {
    padding: 16px;
    font-size: 0.95rem;
  }

  .map-container iframe {
    height: 240px;
  }

  .contact-wrapper h1 {
    font-size: 1.5rem;
  }

  .contact-wrapper p {
    font-size: 1rem;
  }
}


</style>
